export const hideSelector = (filterListIsEmpty: boolean, openFilterSelector: boolean): boolean => {
  if (filterListIsEmpty) {
    return true;
  }

  return !openFilterSelector;
};
